<div *ngIf="!Shitch_LabAddress">
  <label for="exampleInputEmail1">
    <button type="button" (click)="Shitch_LabAddress_click()" class="btn btn-secondary">
      آزمایشگاه مشتری (برای انتخاب کلید کنید)
    </button>
  </label>
  <input [(ngModel)]="inner_Calibration_Lab_Address" (keyup)="set_inner_Calibration_Lab_Address()" name="labAdderss" placeholder="اینجا تایپ کنید ..." type="text" class="form-control">
</div>

<div *ngIf="Shitch_LabAddress">
  <label for="exampleInputEmail1">
    <button type="button" (click)="Shitch_LabAddress_click()" class="btn btn-secondary">
      آزمایشگاه مشتری (برای تایپ کلید کنید)
    </button>
  </label>
  <select class="custom-select" [(ngModel)]="inner_Calibration_Lab_Address" (change)="set_inner_Calibration_Lab_Address()" name="labAdderss" >
    <option value="">انتخاب کنید</option>
    <option *ngFor="let item of Datalist_LabAddress" [value]="item">{{item}}</option>
  </select>
</div>